import { asyncSerializer, Serializer } from '@lib';
import { getFlightsResultInitialState } from './get-flights-result.reducer';
import { GetFlightsResultState } from './get-flights-result.state';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getFlightsResultStorageDeserializer = (rawObject: any) => {
  return {
    ...getFlightsResultInitialState,
    ...rawObject,
  } as GetFlightsResultState;
};

export const getFlightsResultStorageSync: Serializer<GetFlightsResultState> = {
  deserialize: getFlightsResultStorageDeserializer,
};
